if (!customElements.get('isto-fabric-and-fit')) {
  class IstoFabricAndFit extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = -1;
      this.observer = null;
      this.mobileQuery = window.matchMedia('(max-width: 1024px)');
      this.edgePauseLock = false;
      this.edgePauseTimeout = null;
    }

    connectedCallback() {
      this.carousel = this.querySelector('[data-fabric-fit-carousel]');
      this.mediaItems = Array.from(this.querySelectorAll('[data-fabric-fit-media]'));
      this.textItems = Array.from(this.querySelectorAll('[data-fabric-fit-text]'));

      if (!this.mediaItems.length || !this.textItems.length) return;

      this.setActiveIndex(0);
      this.createObserver();
      this.setupScrollHandover();

      this.onMobileQueryChange = () => {
        this.createObserver();
        this.setupScrollHandover();
      };
      this.mobileQuery.addEventListener('change', this.onMobileQueryChange);

      this.onSectionLoad = (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) {
          this.connectedCallback();
        }
      };
      document.addEventListener('shopify:section:load', this.onSectionLoad);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onMobileQueryChange) {
        this.mobileQuery.removeEventListener('change', this.onMobileQueryChange);
      }
      if (this.onSectionLoad) {
        document.removeEventListener('shopify:section:load', this.onSectionLoad);
      }
      if (this.wheelHandler) {
        this.carousel.removeEventListener('wheel', this.wheelHandler, { passive: false });
      }
      if (this.mouseMoveHandler) {
        window.removeEventListener('mousemove', this.mouseMoveHandler);
      }
    }

    setupScrollHandover() {
      if (this.wheelHandler) {
        this.carousel.removeEventListener('wheel', this.wheelHandler, { passive: false });
      }
      if (this.mouseMoveHandler) {
        window.removeEventListener('mousemove', this.mouseMoveHandler);
      }

      if (this.mobileQuery.matches) return;

      this.lastMouseX = null;
      this.lastMouseY = null;

      this.mouseMoveHandler = (e) => {
        this.lastMouseX = e.clientX;
        this.lastMouseY = e.clientY;
      };
      window.addEventListener('mousemove', this.mouseMoveHandler, { passive: true });

      this.wheelHandler = (e) => {
        if (this.lastMouseX === null || this.lastMouseY === null) return;

        const rect = this.carousel.getBoundingClientRect();
        const isInside =
          this.lastMouseX >= rect.left &&
          this.lastMouseX <= rect.right &&
          this.lastMouseY >= rect.top &&
          this.lastMouseY <= rect.bottom;

        if (!isInside) return;

        const scrollTop = Math.round(this.carousel.scrollTop);
        const maxScroll = Math.round(this.carousel.scrollHeight - this.carousel.clientHeight);

        const isLastImage = this.activeIndex === this.mediaItems.length - 1;
        const isFirstImage = this.activeIndex === 0;
        
        const bottomTolerance = isLastImage ? 100 : 5;
        const topTolerance = isFirstImage ? 100 : 5;

        const isAtBottom = scrollTop >= maxScroll - bottomTolerance;
        const isAtTop = scrollTop <= topTolerance;

        const carouselMid = rect.top + rect.height / 2;
        const targetViewportY = window.innerHeight * 0.42;
        const isCentered = Math.abs(carouselMid - targetViewportY) < 30;

        const scrollingDown = e.deltaY > 0;
        const scrollingUp = e.deltaY < 0;

        if (!isCentered) {
          e.preventDefault();
          window.scrollBy(0, e.deltaY);
          return;
        }

        if ((isAtBottom && scrollingDown) || (isAtTop && scrollingUp)) {
          if (this.edgePauseLock) {
            e.preventDefault();
            return;
          }
          
          e.preventDefault();
          window.scrollBy(0, e.deltaY);
          return;
        }
      };

      this.carousel.addEventListener('wheel', this.wheelHandler, { passive: false });
    }

    createObserver() {
      if (this.observer) this.observer.disconnect();

      const isMobile = this.mobileQuery.matches;
      const options = { root: this.carousel, threshold: 0.5 };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.dataset.index);
            this.setActiveIndex(index);
          }
        });
      }, options);

      this.mediaItems.forEach((item) => this.observer.observe(item));
    }

    setActiveIndex(index) {
      if (index === this.activeIndex) return;
      const prevIndex = this.activeIndex;
      this.activeIndex = index;

      if (!this.mobileQuery.matches) {
        const isEdge = index === 0 || index === this.mediaItems.length - 1;
        if (isEdge) {
          this.edgePauseLock = true;
          if (this.edgePauseTimeout) clearTimeout(this.edgePauseTimeout);
          this.edgePauseTimeout = setTimeout(() => {
            this.edgePauseLock = false; 
          }, 400);
        } else {
          this.edgePauseLock = false;
        }
      }

      const prevItem = this.textItems.find((item) => Number(item.dataset.index) === prevIndex);
      const nextItem = this.textItems.find((item) => Number(item.dataset.index) === index);

      let skipTransition = false;
      if (prevItem && nextItem) {
        const prevContent = prevItem.innerHTML.trim();
        const nextContent = nextItem.innerHTML.trim();
        if (prevContent === nextContent) {
          skipTransition = true;
        }
      }

      this.textItems.forEach((item) => {
        const isActive = Number(item.dataset.index) === index;

        if (skipTransition) {
          item.style.transition = 'none';
        }

        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-hidden', String(!isActive));

        if (skipTransition) {
          item.offsetHeight;
          item.style.transition = '';
        }
      });
    }
  }

  customElements.define('isto-fabric-and-fit', IstoFabricAndFit);
}
